<!-- top navbar-->
<header class="topnavbar-wrapper lattice">
  <nav class="navbar topnavbar">
    <div class="navbar-header">
      <!-- Client/Logo section -->
      @if (isShowcaseUser) {
        <div class="brand-logo d-flex">
          <a href="/" class="btn">
            <img class="img-fluid" [src]="logoUrl" width="67" alt="Client logo" [title]="logoTitle" />
          </a>
          <div class="btn-group dropend">
            <button
              type="button"
              class="btn dropdown-toggle dropdown-toggle-split"
              data-bs-toggle="dropdown"
              aria-expanded="false">
              <span class="visually-hidden">Toggle client select</span>
            </button>
            <ul class="dropdown-menu clients-dropdown-menu">
              <li>
                <button class="dropdown-item" type="button" (click)="onClientChange()">-</button>
              </li>
              @for (client of clientLookupItems; track client.id) {
                <li>
                  <button class="dropdown-item" type="button" (click)="onClientChange(client.id)">
                    {{ client.name }}
                  </button>
                </li>
              }
            </ul>
          </div>
        </div>
      } @else {
        <a href="/">
          <div class="brand-logo">
            <img class="img-fluid" [src]="logoUrl" width="67" alt="Client logo" [title]="logoTitle" />
          </div>
        </a>
      }
    </div>

    <!-- Desktop Navigation -->
    <ul class="navbar-nav flex-fill flex-row d-none d-lg-flex">
      @if (isAuthenticated) {
        <!-- Security/Impersonation -->
        @if (canImpersonate) {
          <li class="nav-item d-md-block">
            <button
              type="button"
              class="mt-2 btn"
              [class]="impersonationButtonClass"
              [title]="impersonationButtonTitle"
              (click)="openImpersonationModal()">
              Impersonation
            </button>
          </li>
        }

        <li class="nav-item ms-auto">
          <a class="nav-link" (click)="navigateToProjects()" style="cursor: pointer" title="Projects">
            <span>My Projects</span>
          </a>
        </li>

        @if (isAdmin) {
          <li class="nav-item">
            <a class="nav-link" (click)="navigateToAdmin()" style="cursor: pointer" title="Admin">
              <span>Admin</span>
            </a>
          </li>
        }

        <eng-notifications />

        <!-- User info -->
        <li class="nav-item d-md-block">
          <a class="nav-link" (click)="onUserMenuClick()" style="cursor: pointer">
            @if (isAdmin) {
              <span class="badge text-bg-danger">ADMIN</span>
            }
            {{ userName }}
          </a>
        </li>

        <li class="nav-item d-md-block">
          <a class="nav-link" (click)="onLogout()" style="cursor: pointer">Log off</a>
        </li>
      } @else {
        <li class="nav-item ms-auto d-md-block">
          <a class="nav-link active" (click)="onLogin()" style="cursor: pointer">Log In</a>
        </li>
      }
    </ul>

    <!-- Mobile Menu Button -->
    @if (isAuthenticated) {
      <button type="button" class="mobile-menu-toggle d-lg-none" (click)="toggleMobileMenu()">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
          <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" />
        </svg>
      </button>
    } @else {
      <!-- Show login link for unauthenticated users on mobile -->
      <div class="px-3 d-lg-none">
        <a class="nav-link text-white" (click)="onLogin()" style="cursor: pointer">Log In</a>
      </div>
    }
  </nav>

  <!-- Mobile Overlay Menu -->
  <div id="mobileMenuOverlay" class="mobile-menu-overlay" [class.show]="isMobileMenuOpen">
    <div class="mobile-menu-backdrop" (click)="closeMobileMenu()"></div>
    <div class="mobile-menu-panel">
      <div class="mobile-menu-header">
        <h2 class="mobile-menu-title">Menu</h2>
        <button type="button" class="mobile-menu-close" (click)="closeMobileMenu()">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
            <path
              fill-rule="evenodd"
              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
              clip-rule="evenodd" />
          </svg>
        </button>
      </div>

      <div class="mobile-menu-content">
        @if (isAuthenticated) {
          <!-- Security/Impersonation placeholder for mobile -->

          <div class="mobile-menu-item">
            <a class="mobile-menu-link" (click)="navigateToProjects()" style="cursor: pointer">
              <span>My Projects</span>
            </a>
          </div>

          @if (isAdmin) {
            <div class="mobile-menu-item">
              <a class="mobile-menu-link" (click)="navigateToAdmin()" style="cursor: pointer">
                <span>Admin</span>
              </a>
            </div>
          }

          <div class="mobile-menu-item mobile-menu-user">
            <a class="mobile-menu-link" (click)="onUserMenuClick()" style="cursor: pointer">
              @if (isAdmin) {
                <span class="badge text-bg-danger me-2">ADMIN</span>
              }
              <span class="mobile-menu-username">{{ userName }}</span>
            </a>
          </div>

          <div class="mobile-menu-item">
            <a class="mobile-menu-link" (click)="onLogout()" style="cursor: pointer">Log off</a>
          </div>
        } @else {
          <div class="mobile-menu-item">
            <a class="mobile-menu-link" (click)="onLogin()" style="cursor: pointer">Log In</a>
          </div>
        }
      </div>
    </div>
  </div>
</header>
